import { Injectable } from "@angular/core";
@Injectable()
export class TermsConditions {
  TermsID: string;
  TermsCondition: string;
  TermsUsage: string;
  IssuedDate: string;
  AcceptedDate: string;
  Version: string;
  CountryCode: string;
  Terms2: string;
  Terms3: string;
  Terms4: string;
  Terms5: string;
  Terms6: string;
}
